module.exports = __webpack_public_path__ + "assets/img/ic-close.c9d8d69c.svg";